/**
 * router.tsx — 前端路由表
 */
import { createBrowserRouter } from 'react-router-dom';
import App from './App';
import HomePage from './pages/HomePage';
import CategoryPage from './pages/CategoryPage';
import PromptDetailPage from './pages/PromptDetailPage';
import SubmitPage from './pages/SubmitPage';
import SubscribePage from './pages/SubscribePage';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'category/:slug', element: <CategoryPage /> },
      { path: 'prompt/:id', element: <PromptDetailPage /> },
      { path: 'submit', element: <SubmitPage /> },
      { path: 'subscribe', element: <SubscribePage /> },
    ],
  },
]);
